module.exports = __webpack_public_path__ + "media/excellusbcbs-home-viewports@md-8b8b68441198d32967e1fff99feb0076.png";